import { navChannels } from "@/mocks/chigua";

export default function Footer() {
  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="border-t border-sand/50 bg-cream">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.2fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-ember text-cream">
                <i className="ri-emotion-happy-line text-lg" />
              </span>
              <span className="font-display-x text-2xl font-black tracking-wide">98吃瓜</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink/60">
              把视频片段、截图合集、录屏流出、直播回放与表情包按传播节奏统一归档，
              方便你快速取素材、跟节奏。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-ink">内容分区</h4>
            <ul className="mt-4 space-y-2.5">
              {navChannels.map((c) => (
                <li key={c.id}>
                  <button
                    type="button"
                    onClick={() => go(c.id)}
                    className="text-sm text-ink/60 transition hover:text-ember"
                  >
                    {c.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-ink">使用说明</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-ink/60">
              <li>素材逐条标来源</li>
              <li>按时间线归档</li>
              <li>表情包仅供传播</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-ink">回到顶部</h4>
            <button
              type="button"
              onClick={() => go("top")}
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-ember px-5 py-2.5 text-sm font-bold text-cream transition hover:bg-[#c74423]"
            >
              <i className="ri-arrow-up-line" />
              返回顶部
            </button>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-sand/60 pt-6 sm:flex-row">
          <p className="text-xs text-ink/45">© 2026 98吃瓜 · 素材专题合集浏览站</p>
          <p className="flex items-center gap-1.5 text-xs text-ink/45">
            素材仅供个人取用与传播参考，请尊重原出处版权
            <i className="ri-verified-badge-line text-ember" />
          </p>
        </div>
      </div>
    </footer>
  );
}